<template>
  <div class="field zapi-input-number">
    <span v-if="label">
      <strong>{{ label }}: </strong>
      <span v-if="required" class="p-invalid">*</span>
    </span>
    
    <div class="p-inputgroup" :class="{ 'mt-2': label }">
      <!-- Slot opcional para añadir un botón o icono al principio del input -->
      <slot name="prepend"></slot>
      
      <InputNumber
        :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        :placeholder="placeholder"
        :min="min"
        :max="max"
        :mode="mode"
        :currency="currency"
        :locale="locale"
        :minFractionDigits="minFractionDigits"
        :maxFractionDigits="maxFractionDigits"
        :useGrouping="useGrouping"
        :prefix="prefix"
        :suffix="suffix"
        :disabled="disabled"
        :readonly="readonly"
        :class="{ 'p-invalid': errorMessage || invalid }"
        @input="$emit('input', $event)"
        @blur="$emit('blur', $event)"
        @focus="$emit('focus', $event)"
      />
      
      <!-- Slot opcional para añadir un botón o icono al final del input -->
      <slot name="append"></slot>
    </div>
    
    <small v-if="errorMessage" class="p-invalid block mt-1">
      {{ errorMessage }}
    </small>
  </div>
</template>

<script>
export default {
  name: 'ZapiInputNumber',
  props: {
    modelValue: { type: Number, default: null },
    label: { type: String, default: '' },
    placeholder: { type: String, default: 'Ingrese un número' },
    required: { type: Boolean, default: false },
    
    // Validaciones
    min: { type: Number, default: null },
    max: { type: Number, default: null },
    
    // Modos de formato: 'decimal' o 'currency'
    mode: { type: String, default: 'decimal' },
    currency: { type: String, default: 'BOB' }, // Bolivianos por defecto
    locale: { type: String, default: 'es-BO' }, // Formato boliviano (ej: 1.000,50)
    
    // Decimales y separadores
    minFractionDigits: { type: Number, default: null },
    maxFractionDigits: { type: Number, default: null },
    useGrouping: { type: Boolean, default: true }, // Muestra separador de miles
    
    // Textos extra
    prefix: { type: String, default: '' },
    suffix: { type: String, default: '' },
    
    // Estados
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    invalid: { type: Boolean, default: false }, // Fuerza estado de error visual
    errorMessage: { type: [String, Array], default: '' } // Mensaje rojo debajo
  },
  emits: ['update:modelValue', 'input', 'blur', 'focus']
}
</script>

<style scoped>
.p-invalid {
  color: #e24c4c;
}
.zapi-input-number .p-inputnumber {
  width: 100%;
}
</style>
